import axios from "axios";
import { toast } from "react-toastify";
import { API_BASE_PATH } from "../environment";

const BASE_URL = `${API_BASE_PATH}`;

// ✅ Auth headers
const getAuthHeaders = () => {
  const token = localStorage.getItem("authToken") || "";
  return {
    Authorization: token,
    Accept: "application/json",
  };
};

// ✅ Error handler
const showAxiosError = (error: any, fallback: string) => {
  const detail = error?.response?.data?.detail || error?.message || fallback;
  toast.error(detail);
  console.error(detail);
};

export interface ContentMessage {
  content_type: "sms" | "whats_app" | "email";
  Attachment: string | null;
  client_id: string;
  content_description: string | null;
  service_type: string;
  creat_tags: string | null;
  DLT_operator_name: string;
  content_access: "public" | "private" | "shared";
  sender_id: string;
  DLT_templete_name_or_id: string;
  module: string;
  DLT_approved: "approved" | "pending" | "rejected";
  lead_field: string | null;
  content_name: string;
  templet_type: string | null;
  agent_field: string | null;
  content_id: string;
  media_type: "image" | "video" | "document" | null;
  message: string;
  created_at?: string;
  updated_at?: string;
}

// ✅ Create Content Messager
export const createContentMessager = async (formData: FormData) => {
  try {
    const res = await axios.post(
      `${BASE_URL}/post/content/messager`,
      formData,
      {
        headers: {
          ...getAuthHeaders(),
          "Content-Type": "multipart/form-data",
        },
      }
    );
    toast.success("Content messager created successfully");
    return res.data;
  } catch (error) {
    showAxiosError(error, "Failed to create content messager");
    throw error;
  }
};

// ✅ Get All Content Messagers
export const getAllContentMessagers = async () => {
  try {
    const res = await axios.get(`${BASE_URL}/get/all/contentmesseger`, {
      headers: getAuthHeaders(),
    });
    return res.data;
  } catch (error) {
    showAxiosError(error, "Failed to fetch content messagers");
    throw error;
  }
};

// ✅ Update Content Messager
export const updateContentMessager = async (
  contentId: string,
  formData: FormData
) => {
  try {
    const res = await axios.put(
      `${BASE_URL}/update/content/messager/${contentId}`,
      formData,
      {
        headers: {
          ...getAuthHeaders(),
          "Content-Type": "multipart/form-data",
        },
      }
    );
    toast.success("Content messager updated successfully");
    return res.data;
  } catch (error) {
    showAxiosError(error, "Failed to update content messager");
    throw error;
  }
};

// ✅ Delete Content Messager
export const deleteContentMessager = async (contentId: string) => {
  try {
    const res = await axios.delete(
      `${BASE_URL}/delete/content/messager/${contentId}`,
      {
        headers: getAuthHeaders(),
      }
    );
    return res.data;
  } catch (error) {
    showAxiosError(error, "Failed to delete content messager");
    throw error;
  }
};
